import { useDispatch } from "react-redux";
import {
  showFilterOverlay,
  showSortOverlay
} from "../../state/modules/layout/actions";
import { withTranslation } from "../../components/translation/";
import FilterAndSort from "../../components/FilterAndSort";

const ConnectedSmallFilterAndSort = props => {
  const dispatch = useDispatch();

  return (
    <FilterAndSort
      showFilterOverlay={() => dispatch(showFilterOverlay())}
      showSortOverlay={() => dispatch(showSortOverlay())}
      {...props}
    />
  );
};

export default withTranslation(ConnectedSmallFilterAndSort);
